export default "__VITE_ASSET__2ceb6a36__"